import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable()
export class ApiService {
  constructor(private http: HttpClient) {}

  get(path: string, params: HttpParams = new HttpParams(), responseType?: any): Observable<any> {
    return this.http.get(`${environment.apiUrl}${path}`, { params, responseType }).pipe(catchError(this.formatErrors));
  }

  put(path: string, body: any = {}): Observable<any> {
    return this.http.put(`${environment.apiUrl}${path}`, JSON.stringify(body)).pipe(catchError(this.formatErrors));
  }

  post(path: string, body: any = {}, params: HttpParams = new HttpParams(), responseType?: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}${path}`, JSON.stringify(body), { params, responseType }).pipe(catchError(this.formatErrors));
  }

  delete(path: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}${path}`).pipe(catchError(this.formatErrors));
  }

  private formatErrors(error: any) {
    return throwError(() => error.error);
  }
}
